<div class="tab-flex-container">
  <div id="contact-details">
    <h6 class="section-header-font">
      {{ entityType === entityTypeEnum.Carrier ? "Carrier" : " MGA" }} details
    </h6>
    <div class="section">
      <div>
        <hr />
        <div class="small-container">
          <div class="border-line merge-span-2">
            <label class="text">Address</label>
            @if (details.addressLine1 || details.addressLine2) {
              <p
                class="desc"
                >
                {{ details.addressLine1 ? details.addressLine1 + ", " : "" }}
              </p>
            }
            @if (details.addressLine2) {
              <p class="desc">
                {{ details.addressLine2 ? details.addressLine2 + ", " : "" }}
              </p>
            }
            @if (details.city || details.state || details.postcode) {
              <p
                class="desc"
                >
                {{ details.city ? details.city + ", " : "" }}
                {{ details.state ? details.state + ", " : "" }}
                {{ details.postcode ? details.postcode + ", " : "" }}
              </p>
            }
            <p class="desc">
              {{ details.country ? details.country : "" }}
            </p>
          </div>
          <div class="border-line">
            <label class="text"> Contact number </label>
            <p class="desc">
              {{ details.telephone ? details.telephone : "-" }}
            </p>
          </div>
          <div class="border-line">
            <label class="text">Website</label>
            <p class="desc">
              <a class="cursor" (click)="goToLink(details.website)">{{
                details.website
              }}</a>
            </p>
          </div>
          <div class="border-line">
            <label class="text"> CEO </label>
            <p class="desc">{{ details.ceo ? details.ceo : "-" }}</p>
          </div>
          <div class="border-line">
            <label class="text">Group </label>
            <p class="desc" [ngClass]="details?.groupName ? 'underline-link cursor' : ''" (click)="goToGroupDetails()">
              {{ details?.groupName ? details.groupName : "-" }}
            </p>
          </div>

          @if (entityType === entityTypeEnum.Carrier) {
            <div
              class="border-line merge-span-2"
              >
              <label class="text">Company Type </label>
              <p class="desc">
                {{ details?.carrierType ? details?.carrierType : "-" }}
              </p>
            </div>
          }

          <div class="border-line merge-span-2">
            <label class="text">Notes </label>
            <p class="desc">
              {{ details?.notes ? details?.notes : "-" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="codes">
    <h6 class="section-header-font">Codes</h6>
    <div class="section">
      <hr />

      <div
        [ngClass]="
          entityType === entityTypeEnum.MGA
            ? 'no-ratings-grid'
            : 'grid-container'
        "
        >
        @for (item of codes; track item) {
          <div class="border-line">
            <label class="text">{{ transform(item.name) }}</label>
            <p class="desc">{{ item.code ? item.code : "-" }}</p>
          </div>
        }
      </div>
    </div>
  </div>
  @if (entityType === entityTypeEnum.Carrier) {
    <div id="ratings-summary">
      <h6 class="section-header-font">Ratings summary</h6>
      <div class="section">
        <hr />
        @for (item of ratings; track item) {
          <div class="grid-container">
            <div>
              <div class="border-line">
                <label class="text">{{
                  item.code ? item.name + " (" + item.code + ")" : item.name
                }}</label>
                <p class="desc">
                  {{ item.rating ? item.rating : "-" }}
                  @if (item.outlook) {
                    <span><br />{{ item.outlook }}</span>
                  }
                  @if (item.date) {
                    <span
                      ><br />
                      {{ item.date | date : "MMM d, y" }}</span
                      >
                    }
                  </p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
